import React from "react";
// Images
import imgCord from "../images/Cord.png";
import imgCord1 from "../images/Cord1.png";
import imgCord2 from "../images/Cord2.png";

class Cord extends React.Component {
  render() {
    let classes = "cord"
    if (this.props.side === "left") {
      classes = classes.concat(" ", "flip");
    }

    let display = null;
    if (this.props.isCordLeft === (this.props.side === "left")) {
      if (this.props.dashType === "F") {
        display = <img src={imgCord} />
      } else {
        display = null;
      }
    } else {
      if (this.props.switches === 0) {
        display = null;
      } else if (this.props.switches === 1) {
        display = <img src={imgCord1} />
      } else {
        display = <img src={imgCord2} />
      }
    }

    return (
      <div className={classes}>
        {display}
      </div>

    )
  }
}
export default Cord